import TweenMax, { Power3 } from 'gsap'
require('gsap/ScrollToPlugin') // eslint-disable-line

export const createBody = function (body) {
  const keys = Object.keys(body)
  const queryString = keys.reduce((previous, current) => {
    return previous += `&${current}=${body[current]}` // eslint-disable-line
  }, '')
  return queryString.substr(1)
}

export const extractBody = function (queryString) {
  if (queryString[0] === '?') queryString = queryString.slice(1)
  const pairs = queryString.split('&')
  const result = {}
  pairs.forEach((pair) => {
    pair = pair.split('=')
    result[pair[0]] = decodeURIComponent(pair[1] || '')
  })
  return JSON.parse(JSON.stringify(result))
}

export const hash = function (c) {
  const s = JSON.stringify(c)
  let hash = 0
  if (s.length === 0) return hash
  for (let i = 0; i < s.length; i++) {
    const chr = s.charCodeAt(i)
    hash = ((hash << 5) - hash) + chr
    hash |= 0
  }
  return hash
}

export const getCleanLink = function (link) {
  if (!link) return ''
  try {
    // Normalize any absolute URL to a relative path to avoid host/port mismatches
    if (/^https?:\/\//i.test(link)) {
      const u = new URL(link)
      return `${u.pathname}${u.search}${u.hash}`
    }
    return link
  } catch (e) {
    return link
  }
}

export const getImageUrl = function (image, size = 'full') {
  if (
    image &&
    image.sizes &&
    image.sizes[size]
  ) {
    return image.sizes[size]
  } else if (
    image &&
    image.url
  ) {
    return image.url
  } else {
    return ''
  }
}

export const getFeaturedImageFromPost = function (post, size = 'full') {
  if (
    post &&
    post.featured_image &&
    post.featured_image.file &&
    post.featured_image.sizes &&
    post.featured_image.sizes[size]
  ) {
    const baseArray = post.featured_image.file.split('/')
    const base = `${baseArray[0]}/${baseArray[1]}`
    return `${window.location.protocol}//${window.location.hostname}/wp-content/uploads/${base}/${post.featured_image.sizes[size].file}`
  } else if (
    post &&
    post.featured_image &&
    post.featured_image.file
  ) {
    return `${window.location.protocol}//${window.location.hostname}/wp-content/uploads/${post.featured_image.file}`
  } else {
    return ''
  }
}

export const nl2br = function (str) {
  if (typeof str !== 'string') return ''
  return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')
}

export const scrollTo = function (y, duration = 1) {
  TweenMax.to(window, duration, { scrollTo: { y, ease: Power3.easeOut } })
}

export const extractYoutubeId = function (url) {
  return url.match(/^(?:http(?:s)?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:(?:watch)?\?(?:.*&)?v(?:i)?=|(?:embed|v|vi|user)\/))([^\?&\"'>]+)/)[1] // eslint-disable-line
}

export const extractVimeoId = function (url) {
  return url.match(/(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/)[5] // eslint-disable-line
}

export const promiseTl = function (timeline) {
  return new Promise(function (resolve) {
    timeline.eventCallback('onComplete', function () { resolve(true) })
  })
}

export const getBrowser = function () {
  if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
    return 'opera'
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    return 'chrome'
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    return 'safari'
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    return 'firefox'
  } else if ((navigator.userAgent.indexOf('MSIE') !== -1) || (!!document.documentMode === true)) {
    return 'IE'
  } else {
  }
}

export default {
  createBody,
  extractBody,
  hash,
  getCleanLink,
  getImageUrl,
  getFeaturedImageFromPost,
  nl2br,
  scrollTo,
  extractYoutubeId,
  extractVimeoId,
  promiseTl,
  getBrowser
}
